import { FeePaymentList } from "./FeePaymentList";
import { FeePaymentCreate } from "./FeePaymentCreate";
import { FeePaymentShow } from "./FeePaymentShow";

export default {
    list: FeePaymentList,
    create: FeePaymentCreate,
    show: FeePaymentShow
};
